import { useSettings } from 'Settings'
import Graph from '../Graph'
import { STSGraph } from './STS'
import ValueTransform from 'ValueTransform'
import { getBorderBreaks, setSectionTo } from 'Vectorgraph'


const VAUX = ({vaux, ...props}) => {
	const [settings] = useSettings()
	const sts = STSGraph()
	let graph = []

	const cvaux = settings['vaux'][vaux]

	if (!cvaux['enable'].value)
		return (<></>)

	const acc = settings['supervisory level']['v_lvl_acc'].value
	const v_ulp_ldo = parseFloat(settings['ldo levels']['v_ulp_ldo'].value)
	const v_aux_ldo = parseFloat(settings['ldo levels']['v_aux_ldo'].value)
	const v_apl_max_hi = ValueTransform(settings['supervisory level']['v_apl_max_hi'].value, acc)
	const v_bat_min_hi_dis = ValueTransform(settings['supervisory level']['v_bat_min_hi_dis'].value, acc)
	const cct = cvaux['constantly connect to'].value

	graph = sts

	getBorderBreaks(graph, v_bat_min_hi_dis, false).forEach(([from, to]) => {
		if (from < 4 && from > 3)
			from = 4
		graph = setSectionTo(graph, from, to, 0)
	})


	if (cct === 1) {
		getBorderBreaks(graph, v_ulp_ldo, true).forEach(([from, to]) => {
			graph = setSectionTo(graph, from, to, v_ulp_ldo)
		})
	} else if (cct !== 0) {
		getBorderBreaks(graph, v_apl_max_hi, true).forEach(([from, to]) => {
			graph = setSectionTo(graph, from, to, v_aux_ldo)
		})
	}

	return (
		<Graph {...props} points={graph} />
	)
}

export default VAUX
